function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M5 3c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h6.684a6.926 6.926 0 01-.604-2H5V9h14v2.08a6.926 6.926 0 012 .604V5c0-1.103-.897-2-2-2H5zm1 2a1 1 0 110 2 1 1 0 010-2zm3 0a1 1 0 110 2 1 1 0 010-2zm3 0h7v2h-7V5zm6 8c-2.8 0-5 2.2-5 5s2.2 5 5 5c1 0 2-.3 2.8-.8l1.8 1.8 1.4-1.4-1.8-1.8c.5-.8.8-1.8.8-2.8 0-2.8-2.2-5-5-5zm0 2c1.7 0 3 1.3 3 3s-1.3 3-3 3-3-1.3-3-3 1.3-3 3-3z"
});

function SvgPreviewinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    width: 28,
    height: 28
  }, props), _ref);
}

export default SvgPreviewinline;